<template>
   
      
           
             <canvas :id="id"></canvas>
       
       
    
    
</template>

<script>
export default {
    name: "ChartComponent",
    props:{
        
        id:{
            type: String,
            required: true
        },
        type:{
            type: String,
            required: true
        },
        
        labels:{
            type: Array,
            required: true
        },
        dataset:{
            type: Array,
            required: true
        },
        options:{
            type: Object,
            required: true
        }
        

    },
    components: {

    },
    data() {
       
        return {
            chartId:this.id,
             chartData: {
                 type: this.type,
                 data:{
                    labels:this.labels,
                    datasets:this.dataset,
                 },
                options:this.options
                 
             }
        }
    },
    methods: {
        createChart(chartId, chartData) {
            const ctx = document.getElementById(chartId);
            const myChart = new Chart(ctx, {
                type: chartData.type,
                data: chartData.data,
                options: chartData.options,
            });
        }
    },
    mounted() {
        this.createChart(this.chartId, this.chartData);
    }
}
</script>
